<template>
  <div>
    <div class="d-flex">
      <h2 class="titleText--text">ROI parameters</h2>
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon  v-bind="attrs" size="medium"
              v-on="on" color="blue" class="ml-3 mt-1">mdi-information-outline</v-icon>
            </template>
            <span> ROI parameters</span>
          </v-tooltip>
        </div>
   <v-card flat class="custom-shadow mb-5 mt-2">
    <v-card-text>
      <div v-if="this.list_roi_lcomb_varlist.length == 0 && !searchTerm" class="d-flex justify-center">
        <v-progress-circular
        indeterminate
        color="blue"
        size="50"
        />
      </div>
      <div v-else class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <div style="width: 600px">
            <v-select
            multiple
            v-model="selected_list_roi_lcomb_varlist"
            :items="list_roi_lcomb_varlist"
            hide-details="auto"
            placeholder="Select variables"
            background-color="#f3f5f8"
            solo
            style="border-radius: 8px;"
            flat
        >
          <template v-slot:prepend-item>
            <v-text-field 
              v-model="searchTerm"
              placeholder="Search"
              @input="searchItems"
              hide-details
              dense
              clearable
              flat
              solo
              solo-filled
              prepend-inner-icon="mdi-magnify"
            />
          </template>
          <template v-slot:selection="{ item, index }">
            <v-chip
            close
            small
            color="blue"
            dark
            clear
            light
            @click:close="removeSelectedItems(item)"
            >
              <span class="font-weight-bold">{{ item }}</span>
            </v-chip>
          </template>
          </v-select>
        </div>
          <v-btn
            icon
            color="blue"
            @click="openmanagegroupctrl()"
            class="ml-3"
            title="Create group"
        >
            <v-icon color="blue">mdi-plus-circle</v-icon>
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <v-btn title="Run the Model"
            depressed
            class="ml-3"
            height="42"
            color="blue"
            @click="GetDataClick()"
          >
            <v-icon color="white" class="ml-0 mr-3" right dark>
              mdi-chart-waterfall
            </v-icon>
            <span class="font-weight-bold text-capitalize white--text" >Simulate The Model</span>
          </v-btn>
        </div>
      </div>
    </v-card-text>
  </v-card>
    <NewBarChartROI></NewBarChartROI>
    <ctrlmanagegroup ref="ctrlmanagegroup"></ctrlmanagegroup>
  </div>
</template>

<script>
import { bus } from "../../../main";
import { defineComponent } from "@vue/composition-api";
import ChartModeloutComeROI from "./ModeloutComeCharts/ModelRoiBar.vue";
import ChartBarRoi from "./ModeloutComeCharts/BarRoi.vue";
import ChartBarSpend from "./ModeloutComeCharts/BarSpend.vue";
import ChartBarValue from "./ModeloutComeCharts/BarValue.vue";
import ChartBarExcecution from "./ModeloutComeCharts/BarExcecution.vue";
import ChartBarVolumne from "./ModeloutComeCharts/BarVolumne.vue";
import ChartBarvolumeresponse from "./ModeloutComeCharts/Barvolumeresponse.vue";
import ChartBubble from "./ModeloutComeCharts/ModelOutComeBubbelChart.vue";
import NewBarChartROI from "./ModeloutComeCharts/NewChartROI.vue";
import NewChartTreeMapvolumecontibution from "./ModeloutComeCharts/NewChartTreeMap.vue";
import piechart from "./piechart.vue";
import piechart2 from "./piechart2.vue";
import ctrlmanagegroup from "././ModeloutComeCharts/CtrlManageGroup.vue";
import apifactory from "../api";
export default defineComponent({
  setup() {},
  components: {
    ChartModeloutComeROI,
    piechart,
    piechart2,
    ChartBarRoi,
    ChartBarSpend,
    ChartBarValue,
    ChartBarExcecution,
    ChartBarVolumne,
    ChartBarvolumeresponse,
    ChartBubble,
    ctrlmanagegroup,
    NewBarChartROI,
    NewChartTreeMapvolumecontibution
  },
  data: () => ({
    vexpansionpanels1: [],
    vexpansionpanels2: [],
    vexpansionpanels3: [],
    vexpansionpanels4: [],
    panel: [0, 1, 2],
    panelfirst: 0,
    list_roi_lcomb_varlist: [],
    selected_list_roi_lcomb_varlist: [],
    selected_list_roi_lcomb_varlist_new: [],
    selected_list_roi_lcomb_varlist_save: [],
    selectvar: 0,
    itemroimaindata: [],
    itemalldata: [],
    searchTerm: '',
    copiedItems: []
  }),
  methods: {
    loaddataOnChild() {
      apifactory
        .api_get_model_data()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.itemroimaindata = res.data.roi_total;
            this.itemalldata = res.data;
            this.list_roi_lcomb_varlist = [];
            this.list_roi_lcomb_varlist = this.itemalldata.roi_swaplist;
            this.copiedItems = [...this.list_roi_lcomb_varlist]
            this.get_save_roi_parameters();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    removeSelectedItems (value) {
      this.selected_list_roi_lcomb_varlist = this.selected_list_roi_lcomb_varlist.filter(item => value !== item)
    },
    searchItems() {
      if (!this.searchTerm) {
        this.list_roi_lcomb_varlist = [...this.copiedItems]
      }

      this.list_roi_lcomb_varlist = this.copiedItems.filter((item) => {
        return item.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      });
    },
    loaddataOnChildFromchild(){
this.loaddataOnChild();
    },

    getroilcombvarlist() {
      this.list_roi_lcomb_varlist = [];
      apifactory
        .get_roi_lcomb_varlist()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            this.list_roi_lcomb_varlist = [...Object.keys(res.data)];
            this.copiedItems = [...this.list_roi_lcomb_varlist]
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    GetDataClick() {
      if (this.selected_list_roi_lcomb_varlist != null) {
        apifactory
          .api_get_save_roi_parameters_swap(
            this.selected_list_roi_lcomb_varlist
          )
          .then((res) => {
            if (res.status != 200) {
              alert(res.message);
            } else {
              this.loaddataOnChild();
            }
          })
          .catch(function (error) {
            console.warn(error);
          });
      }
      else
      {
         this.loaddataOnChild();
      }
    },
    GetDataClick_tbd() {
      let temparray = "";
      this.selected_list_roi_lcomb_varlist_save = [];
      if (this.selected_list_roi_lcomb_varlist.length > 0) {
        for (var k = 0; k < this.selected_list_roi_lcomb_varlist.length; k++) {
          temparray = temparray + this.selected_list_roi_lcomb_varlist[k] + ",";
        }
        this.selected_list_roi_lcomb_varlist_new = temparray.substring(
          0,
          temparray.length - 1
        );
      }
      let tempselectvalue = 0;

      let obj = new Object();
      if (this.selectvar) {
        tempselectvalue = 1;
        obj.sep_lcomb = tempselectvalue;
        obj.name = temparray.substring(0, temparray.length - 1);
      } else {
        obj.sep_lcomb = 0;
        obj.name = "";
      }

      this.selected_list_roi_lcomb_varlist_save.push(obj);

      apifactory
        .get_save_roi_params(
          JSON.stringify(this.selected_list_roi_lcomb_varlist_save)
        )
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            //this.list_roi_lcomb_varlist = [...Object.keys(res.data)]
            alert("done");
            bus.$emit("refreshBarSpend");
            bus.$emit("refreshChartBarValue");
            bus.$emit("refreshChartBarRoi");
            bus.$emit("refreshpiechart");
            bus.$emit("refreshpiechart2");
            bus.$emit("refreshChartBarExcecution");
            bus.$emit("refreshChartBarVolumne");
            bus.$emit("refreshChartBarvolumeresponse");
            bus.$emit("refreshChartBubble");
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    getroilcombvarlistdefault() {
      //this.list_roi_lcomb_varlist = [];
      apifactory
        .api_get_save_roi_parameters()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            // alert(JSON.stringify(res.data));
            let tempselectvar = res.data[0].roi_swap;
            //alert(tempselectvar);
            if (parseInt(tempselectvar) === 1) {
              this.selectvar = true;
            }
            let templist = [];
            templist = res.data[0].name;
            let arrayitem = [];
            // alert(tempdatax.split(',')[0]);
            arrayitem = templist.split(",");
            for (var k = 0; k < arrayitem.length; k++) {
              this.selected_list_roi_lcomb_varlist.push(arrayitem[k]);
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    get_save_roi_parameters() {
      //alert("get_save_roi_parameters");
      //this.list_roi_lcomb_varlist = [];
      apifactory
        .api_get_save_roi_parameters()
        .then((res) => {
          // alert(res.id);
          //alert(JSON.stringify(res.data));
          //alert("kk" + JSON.stringify(res.data.roi_swap));
          //alert(res.status);
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            // alert(JSON.stringify(res.data));
            //let tempselectvar = res.data.roi_swap;
            //alert("kk11" + JSON.stringify(tempselectvar));
            for (let element in res.data.roi_swap) {
              //alert("kk11" +JSON.stringify(res.data.roi_swap[element]));
              this.selected_list_roi_lcomb_varlist.push(
                res.data.roi_swap[element].param
              );
              /* alert(res.data.roi_swap[element].param);
              this.selected_list_roi_lcomb_varlist.push(
                res.data[0].roi_swap[element].param
              );*/
            }
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    openmanagegroupctrl() {
      this.$refs.ctrlmanagegroup.OnloadCall(this.itemalldata);
    },
  },
  mounted() {
    //this.getroilcombvarlist();
    // this.getroilcombvarlistdefault();
    this.loaddataOnChild();
  },
});
</script>
<style>
  .custom-shadow {
  box-shadow: 0px 8px 18px rgba(82, 111, 151, 0.06) !important
}
.displaynone{
visibility: hidden;
}
</style>
